(function trackerLocationsSearch(global) {
  'use strict';

  const locationsSearchBox = global.document.querySelector('[data-locations-search-box]');

  /**
   * trackLocationsSearchEvent: tracks the Locations Search click event.
   */
  function trackLocationsSearchEvent(event) {
    const locationsSearchTextInput = locationsSearchBox.querySelector('[data-user-text]');
    if (!event || !event.target || event.target.dataset.searchSubmitLocations === undefined ||
      !locationsSearchTextInput) {
      return;
    }

    const eventGa4 = {
      eventType: 'GA4Event',
      eventName: 'searchterm_events',
      params: {
        search_value: locationsSearchTextInput.value,
        click_target: 'BSP Location search tab'
      }
    };
    document.body.dispatchEvent(new CustomEvent('trackOnDemandEvent', {
      detail: { data: eventGa4 }
    }));
  }

  if (locationsSearchBox) {
    locationsSearchBox.addEventListener('click', trackLocationsSearchEvent);
  }
}(window));

define("trackerLocationsSearch", function(){});

